import React from 'react';

type ParamsT = { count: number; allCount: number };

export default function Status({ count, allCount }: ParamsT): React.ReactNode {
    const completePercent = (count / allCount) * 100;

    return (
        <>
            <div className={`v2table__progress ${count === allCount ? '_complete _full' : ''}`}>
                <div className="v2table__progressInner">
                    <div className="v2table__progressItem" style={{ width: `${completePercent}%` }}>
                        <div className="v2table__progressItemInner" />
                    </div>
                </div>
                <div className="v2table__progressDescription">
                    {count} из {allCount}
                </div>
            </div>
        </>
    );
}
